<template>
  <div class="order-list-page">
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#3ea56e"
      size="128"
      is-full-screen
    />
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout v-else wrap justify-center>
      <v-flex xs12 sm12 md12 lg12 xl12 pa-5>
        
        <!-- Page Header -->
        <div class="page-header mb-5">
          <div class="header-left">
            <div class="header-icon-wrap">
              <v-icon color="white" size="22">mdi-package-variant-closed</v-icon>
            </div>
            <div>
              <h2 class="page-title">Cancelled Orders</h2>
            </div>
          </div>
          <div class="header-actions" v-if="totalData">
            <div class="stat-chip mr-3">
              <v-icon size="14" color="#3ea56e" class="mr-1">mdi-cart-check</v-icon>
              <span>{{ totalData }} Total Cancelled</span>
            </div>
            
            <!-- Download PDF -->
            <!-- <v-btn
              depressed
              class="action-download-btn mr-2"
              height="38px"
              :href="
                baseURL +
                  '/admin/orders/cancelled-list/pdf?sellerId=' +
                  sellerid +
                  '&refundStatus=' +
                  refundStatus +
                  '&from=' +
                  from +
                  '&to=' +
                  to
              "
              target="_blank"
            >
              <v-icon left size="18" color="#ef4444">mdi-file-pdf-box</v-icon>
              <span>Download PDF</span>
            </v-btn> -->

            <!-- Download Excel -->
            <!-- <download-excel :data="user" :fields="json_fields" class="d-inline-block">
              <v-btn
                depressed
                class="action-download-btn"
                height="38px"
              >
                <v-icon left size="18" color="#22c55e">mdi-file-excel</v-icon>
                <span>Download Excel</span>
              </v-btn>
            </download-excel> -->
          </div>
        </div>

        <!-- Main Card -->
        <v-card class="modern-card" elevation="0">
          
          <!-- Filters Bar -->
          <div class="filters-bar py-4 px-5">
            <v-row dense>
              <v-col cols="12" sm="12" md="4" class="py-1">
                <v-autocomplete
                  v-model="sellerid"
                  :items="sellerList"
                  item-text="organization"
                  item-value="_id"
                  outlined
                  clearable
                  dense
                  label="Seller"
                  hide-details
                  prepend-inner-icon="mdi-store-outline"
                  class="modern-input"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3" class="py-1">
                <v-select
                  dense
                  :items="items"
                  v-model="refundStatus"
                  label="Refund Status"
                  outlined
                  clearable
                  hide-details
                  prepend-inner-icon="mdi-cash-refund"
                  class="modern-input"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="4" md="2" class="py-1">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="from"
                      label="From Date"
                      outlined
                      dense
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      class="modern-input"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from"
                    no-title
                    color="#3ea56e"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" md="3" class="py-1">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="to"
                      label="To Date"
                      outlined
                      dense
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      prepend-inner-icon="mdi-calendar"
                      class="modern-input"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to"
                    no-title
                    color="#3ea56e"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>

          <v-divider></v-divider>

          <!-- Orders Container -->
          <div class="orders-container pa-5" v-if="user.length > 0">
            <div
              v-for="item in user"
              :key="item._id._id"
              class="order-card-wrapper mb-4"
            >
              <!-- Order Card Header -->
              <div class="order-card-header">
                <div class="order-card-header-left">
                  <span class="order-id-label">Order</span>
                  <span class="order-id-val clickable-id" @click="info(item.orderId)">#{{ item.orderID ? item.orderID : 'N/A' }}</span>
                  <span class="order-date-divider">•</span>
                  <span class="order-date">{{ item.create_date }}</span>
                </div>
                <div class="order-card-header-right d-flex align-center flex-wrap" style="gap: 12px;">
                  <div class="d-flex align-center">
                    <span class="status-label">Order:</span>
                    <span :class="['status-badge', getStatusClass(item.orderStatus)]">
                      {{ item.orderStatus || 'N/A' }}
                    </span>
                  </div>
                  <div class="d-flex align-center">
                    <span class="status-label">Refund:</span>
                    <span :class="['status-badge', getStatusClass(item.refundStatus || 'Pending')]">
                      {{ item.refundStatus || 'Pending' }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Order Card Body -->
              <div class="order-card-body">
                <v-row align="center">
                  <!-- Collage / Photos -->
                  <v-col cols="12" sm="auto" class="d-flex justify-center justify-sm-start">
                    <div class="collage-container-wrap">
                      <Collage
                        :images="item.photos"
                        style="object-fit: contain !important"
                        :collageSizeMin="1"
                        :collageSizeMax="4"
                        :showNoImagesMsg="true"
                        noImagesMsg="No Images"
                        :showLoadingMsg="false"
                        loadingMsg="Loading..."
                        height="80px"
                        width="80px"
                      />
                    </div>
                  </v-col>

                  <!-- Details -->
                  <v-col cols="12" sm="9" md="6" class="text-left">
                    <div class="items-info-wrap">
                      <h3 class="items-title" :title="item.productname">
                        {{ item.productname }}
                      </h3>
                      
                      <v-row class="customer-info-grid mt-2" dense>
                        <v-col cols="6" sm="4">
                          <div class="info-block">
                            <span class="info-label">Customer Name</span>
                            <span class="info-value" v-if="item.order && item.order.deliveryAddress">
                              {{ item.order.deliveryAddress.firstname }} {{ item.order.deliveryAddress.lastname }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="6" sm="4">
                          <div class="info-block">
                            <span class="info-label">Phone</span>
                            <span class="info-value" v-if="item.customer">
                              {{ item.customer.phone }}
                            </span>
                          </div>
                        </v-col>
                        <v-col cols="6" sm="4">
                          <div class="info-block">
                            <span class="info-label">Payment Type</span>
                            <span class="info-value" v-if="item.order">
                              {{ item.order.paymentType }}
                            </span>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>

                  <!-- Amount -->
                  <v-col cols="12" sm="6" md="2" class="text-left mt-3 mt-md-0">
                    <div class="amount-wrap">
                      <span class="info-label d-block mb-1">Amount</span>
                      <span class="order-amount">Rs. {{ item.TotalAmount }}</span>
                    </div>
                  </v-col>

                  <!-- Actions -->
                  <v-col cols="12" sm="6" md="2" class="text-left text-sm-right mt-3 mt-md-0 d-flex justify-start justify-sm-end align-center" style="gap: 8px;">
                    <template v-if="showRefundActions(item)">
                      <v-btn
                        depressed
                        class="action-approve-btn"
                        @click="updateRefundStatus(item._id, 'APPROVE')"
                      >
                        <v-icon left size="16">mdi-check</v-icon>
                        <span>Approve</span>
                      </v-btn>
                      <v-btn
                        depressed
                        class="action-reject-btn"
                        @click="updateRefundStatus(item._id, 'REJECT')"
                      >
                        <v-icon left size="16">mdi-close</v-icon>
                        <span>Reject</span>
                      </v-btn>
                    </template>
                    <template v-else>
                      <div class="completed-action-badge" style="width: 100%; padding: 8px 4px; background: #f8fafc; border-radius: 8px; border: 1px dashed #cbd5e1; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                        <v-icon size="20" :color="getRefundActionColor(item.refundStatus)">{{ getRefundActionIcon(item.refundStatus) }}</v-icon>
                        <span style="font-size: 10px; font-weight: 600; color: #64748b; margin-top: 4px; text-transform: uppercase; letter-spacing: 0.5px;">
                          Action Taken
                        </span>
                      </div>
                    </template>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div class="empty-state" v-else>
            <v-icon size="56" color="#cbd5e1">mdi-package-variant</v-icon>
            <p class="empty-title">No cancelled orders found</p>
            <p class="empty-subtitle">Try adjusting your filters or date range</p>
          </div>

          <!-- Pagination -->
          <div class="pagination-wrap" v-if="pages > 1">
            <div class="pagination-info">
              <span>Page {{ currentPage }} of {{ pages }}</span>
            </div>
            <v-pagination
              :length="pages"
              :total-visible="7"
              v-model="currentPage"
              color="#3ea56e"
              class="modern-pagination"
            ></v-pagination>
          </div>

        </v-card>
      </v-flex>
    </v-layout>

    <!-- Confirmation Modal -->
    <v-dialog v-model="confirmModal.show" max-width="400">
      <v-card class="modern-card">
        <v-card-title class="text-h6 pt-5 pb-3">Confirm Action</v-card-title>
        <v-card-text class="pt-2 text-body-1" style="font-size: 15px; color: #475569;">
          Are you sure you want to <strong>{{ confirmModal.action ? confirmModal.action.toLowerCase() : '' }}</strong> this refund?
        </v-card-text>
        <v-card-actions class="pb-4 px-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            class="text-capitalize px-4"
            style="border-radius: 8px; font-weight: 600;"
            @click="confirmModal.show = false"
          >
            Cancel
          </v-btn>
          <v-btn
            :color="confirmModal.action === 'APPROVE' ? '#3ea56e' : '#ef4444'"
            class="text-capitalize px-4 white--text"
            depressed
            style="border-radius: 8px; font-weight: 600;"
            @click="executeRefundUpdate"
          >
            Yes, {{ confirmModal.action === 'APPROVE' ? 'Approve' : 'Reject' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar for Notifications -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      bottom
      right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
          dark
          text
          v-bind="attrs"
          @click="snackbar.show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>

<script>
import Collage from "vue-collage";
import axios from "axios";

export default {
  components: {
    Collage,
  },
  data() {
    return {
      confirmModal: {
        show: false,
        orderItemId: null,
        action: '',
      },
      snackbar: {
        show: false,
        text: '',
        color: 'success',
      },
      appLoading: false,
      search: "",
      currentPage: 1,
      pages: 0,
      count: 20,
      totalData: 0,
      refundStatus: null,
      menu1: false,
      menu2: false,
      date: new Date(),
      from: null,
      to: null,
      totalRows: 0,
      ServerError: false,
      headers: [
        { text: " Name", value: "firstname" },
        { text: "Products", value: "productname", tdClass: "tdwidth" },
        { text: "Amount", value: "amount" },
        { text: "Order Date", value: "Orderdate" },
        { text: "Refund Status", value: "refundStatus" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      user: [],
      data: [],
      category: [],
      items: [
        "Pending",
        "Approved",
        "Rejected",
        "Refunded"
      ],
      productList: [],
      sellerList: [],
      sellerid: null,
      productid: null,
      json_fields: {
        FirstName: "order.deliveryAddress.firstname",
        LastName: "order.deliveryAddress.lastname",
        ProductName: "productname",
        Phone: "customer.phone",
        Email: "customer.email",
        Amount: "TotalAmount",
        Payment: "order.paymentType",
        Date: "create_date",
        RefundStatus: "refundStatus"
      },
    };
  },
  mounted() {
    this.getData();
    this.getSellerList();
  },
  watch: {
    from() {
      this.getData();
    },
    to() {
      this.getData();
    },
    currentPage() {
      this.getData();
    },
    refundStatus() {
      this.getData();
    },
    sellerid() {
      this.getData();
    },
  },
  methods: {
    getStatusClass(status) {
      if (!status) return 'status-pending';
      const s = status.toLowerCase();
      if (s.includes('pending')) return 'status-pending';
      if (s.includes('confirm')) return 'status-confirmed';
      if (s.includes('cancel') || s.includes('reject')) return 'status-cancelled';
      if (s.includes('ship')) return 'status-shipped';
      if (s.includes('delivery') || s.includes('out for')) return 'status-out-for-delivery';
      if (s.includes('deliver')) return 'status-delivered';
      if (s.includes('approve') || s.includes('refund')) return 'status-confirmed';
      return 'status-pending';
    },
    showRefundActions(item) {
      if (!item || !item.refundStatus) return true;
      const status = item.refundStatus.toLowerCase();
      if (status.includes('fail')) return true;
      return !(
        status.includes('approved') ||
        status.includes('processing') ||
        status.includes('refunded') ||
        status.includes('rejected')
      );
    },
    getRefundActionIcon(status) {
      if (!status) return 'mdi-check-circle-outline';
      const s = status.toLowerCase();
      if (s.includes('reject')) return 'mdi-close-circle-outline';
      return 'mdi-check-circle-outline';
    },
    getRefundActionColor(status) {
      if (!status) return '#3ea56e';
      const s = status.toLowerCase();
      if (s.includes('reject')) return '#ef4444';
      return '#3ea56e';
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/admin/orders/cancelled-items-list",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          count: this.count,
          page: this.currentPage,
          from: this.from,
          to: this.to,
          refundStatus: this.refundStatus,
          sellerId: this.sellerid,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.user = response.data.data;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
          var vm = this;
          this.user.forEach(function(itm) {
            itm.create_date = itm.create_date ? vm.formatDate(itm.create_date) : '';
            itm.photos = [];

            if (itm.product && itm.product.photos && itm.product.photos.length > 0) {
              itm.photos.push({
                image: vm.mediaUURL + itm.product.photos[0],
              });
            }
          });
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    updateRefundStatus(orderItemId, action) {
      this.confirmModal.orderItemId = orderItemId;
      this.confirmModal.action = action;
      this.confirmModal.show = true;
    },
    executeRefundUpdate() {
      this.confirmModal.show = false;
      this.appLoading = true;
      axios({
        url: "/admin/orders/refund/update",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          orderItemId: this.confirmModal.orderItemId,
          action: this.confirmModal.action,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.snackbar.text = response.data.msg || "Refund status updated successfully.";
            this.snackbar.color = 'success';
            this.snackbar.show = true;
            this.getData();
          } else {
            this.snackbar.text = response.data.msg || "Failed to update refund status.";
            this.snackbar.color = 'error';
            this.snackbar.show = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.error(err);
          this.snackbar.text = (err.response && err.response.data && err.response.data.msg) ? err.response.data.msg : "An error occurred while updating refund status.";
          this.snackbar.color = 'error';
          this.snackbar.show = true;
        });
    },
    getSellerList() {
      axios({
        url: "/seller/activeall",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.sellerList = response.data.data;
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    info(pid) {
      this.$router.push("/orderDetails?id=" + pid);
    },
    formatDate(item) {
      if (!item) return "";
      var dt = new Date(item);
      if (isNaN(dt.getTime())) return "";
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    },
  },
};
</script>

<style scoped>
/* Page Wrapper */
.order-list-page {
  background: #f5f6fa;
  min-height: 100vh;
  font-family: poppinsmedium, sans-serif;
}

/* Page Header */
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}
.header-icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #3ea56e, #2d8257);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.35);
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  line-height: 1.2;
}
.header-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.stat-chip {
  display: flex;
  align-items: center;
  background: #e8f5e9;
  border: 1px solid #c8e6c9;
  border-radius: 20px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  color: #2d8257;
  height: 38px;
}

/* Download Buttons */
.action-download-btn {
  background-color: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 10px !important;
  color: #334155 !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0px !important;
  transition: all 0.2s ease !important;
}
.action-download-btn:hover {
  background-color: #f8fafc !important;
  border-color: #cbd5e1 !important;
  transform: translateY(-1px);
}

/* Main Card */
.modern-card {
  border-radius: 16px !important;
  border: 1px solid #ebebeb !important;
  overflow: hidden;
  background: #ffffff;
}

/* Filters Bar */
.filters-bar {
  background: #ffffff;
}
.modern-input ::v-deep .v-input__slot {
  border-radius: 10px !important;
  font-size: 13px;
  border-color: #e2e8f0 !important;
}

/* Order Card Layout */
.order-card-wrapper {
  background: #ffffff;
  border: 1px solid #eaedf0;
  border-radius: 14px;
  overflow: hidden;
  transition: all 0.2s ease;
  text-align: left;
}
.order-card-wrapper:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);
  border-color: #3ea56e44;
}

.order-card-header {
  background: #f9fafb;
  border-bottom: 1px solid #eaedf0;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}
.order-card-header-left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.order-id-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #8a93a4;
  letter-spacing: 0.5px;
}
.order-id-val {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  margin-left: 4px;
  font-family: monospace;
}
.order-date-divider {
  color: #cbd5e1;
  margin: 0 10px;
}
.order-date {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.order-card-body {
  padding: 20px;
}
.collage-container-wrap {
  position: relative;
  width: 80px;
  height: 80px;
  border: 1.5px solid #3ea56e22;
  border-radius: 10px;
  padding: 6px;
  background: #f8fafc;
  display: inline-block;
  overflow: hidden;
  box-sizing: border-box;
}

.items-info-wrap {
  display: flex;
  flex-direction: column;
}
.items-title {
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 6px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.customer-info-grid {
  margin-top: 6px;
}
.info-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.info-label {
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.3px;
}
.info-value {
  font-size: 13px;
  color: #374151;
  font-weight: 600;
}

.amount-wrap {
  display: flex;
  flex-direction: column;
}
.order-amount {
  font-size: 17px;
  font-weight: 700;
  color: #10b981;
}

/* Action Buttons */
.action-approve-btn {
  border-radius: 10px !important;
  background-color: #e8f5e9 !important;
  color: #2d8257 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0px !important;
  padding: 6px 12px !important;
  height: 34px !important;
  border: 1px solid #c8e6c9 !important;
  transition: all 0.2s ease !important;
}
.action-approve-btn:hover {
  background-color: #3ea56e !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(62, 165, 110, 0.25) !important;
  border-color: #3ea56e !important;
}

.action-reject-btn {
  border-radius: 10px !important;
  background-color: #ffe3e3 !important;
  color: #fa5252 !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0px !important;
  padding: 6px 12px !important;
  height: 34px !important;
  border: 1px solid #ffa8a833 !important;
  transition: all 0.2s ease !important;
}
.action-reject-btn:hover {
  background-color: #fa5252 !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(250, 82, 82, 0.25) !important;
  border-color: #fa5252 !important;
}

.clickable-id {
  cursor: pointer;
  color: #228be6 !important;
  text-decoration: underline;
  transition: color 0.2s ease;
}
.clickable-id:hover {
  color: #1c7ed6 !important;
}

.status-label {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  margin-right: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Status Badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  border-width: 1px;
  border-style: solid;
}
.status-pending {
  background-color: #fff3e0;
  color: #f76707;
  border-color: #ffa94d33;
}
.status-confirmed {
  background-color: #e7f5ff;
  color: #228be6;
  border-color: #748ffc33;
}
.status-cancelled {
  background-color: #ffe3e3;
  color: #fa5252;
  border-color: #ffa8a833;
}
.status-shipped {
  background-color: #f8f0fc;
  color: #be4bdb;
  border-color: #da77f233;
}
.status-out-for-delivery {
  background-color: #e6fcf5;
  color: #0ca678;
  border-color: #38d9a933;
}
.status-delivered {
  background-color: #e8f7ee;
  color: #3ea56e;
  border-color: #3ea56e33;
}

/* Empty State */
.empty-state {
  padding: 64px 20px;
  text-align: center;
}
.empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #64748b;
  margin: 12px 0 4px;
}
.empty-subtitle {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

/* Pagination */
.pagination-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 14px 20px;
  border-top: 1px solid #f0f0f0;
  background: #fafafa;
}
.pagination-info {
  font-size: 12px;
  color: #9e9e9e;
  font-weight: 500;
}
.modern-pagination ::v-deep .v-pagination__item {
  border-radius: 8px !important;
  font-size: 13px !important;
  min-width: 34px !important;
  height: 34px !important;
  box-shadow: none !important;
}
.modern-pagination ::v-deep .v-pagination__navigation {
  border-radius: 8px !important;
  box-shadow: none !important;
}

.tdwidth {
  width: 50% !important;
}
</style>
